var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .camera-st0{fill:#FFFFFF;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M283.7,339.5H159c-10.1,0-18.2-8.2-18.2-18.2v-96.6c0-10.1,8.2-18.2,18.2-18.2h124.7     c10.1,0,18.2,8.2,18.2,18.2v96.6C301.9,331.3,293.7,339.5,283.7,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M358.4,316.4l-34.3-20.5c-2.3-1.3-3.6-3.6-3.6-6v-63.2c0-2.4,1.3-4.6,3.6-6l34.3-20.5c5.5-3.3,12.9,0.2,12.9,6     v104.2C371.2,316.2,363.9,319.7,358.4,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M226.8,172.5h-38.3c-5.7,0-10.4,4.7-10.4,10.4v0c0,5.7,4.7,10.4,10.4,10.4h38.3c5.7,0,10.4-4.7,10.4-10.4v0     C237.2,177.2,232.6,172.5,226.8,172.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera.9832fe66.svg";
export { ForwardRef as ReactComponent };